/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Plan_DescriptionInputs */

const en_settings_plan_description = /** @type {(inputs: Settings_Plan_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan and payment method`)
};

const es_settings_plan_description = /** @type {(inputs: Settings_Plan_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan y método de pago`)
};

/**
* | output |
* | --- |
* | "Your plan and payment method" |
*
* @param {Settings_Plan_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_plan_description = /** @type {((inputs?: Settings_Plan_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Plan_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_plan_description(inputs)
	return en_settings_plan_description(inputs)
});